/* IllumiWave Main JS */
(function(){
  'use strict';
  
  // ---- SCROLL ANIMATIONS ----
  // Add class to body FIRST so CSS knows JS is running
  document.body.classList.add('iw-js-loaded');
  
  function initAnimations() {
    var animEls = document.querySelectorAll('.iw-anim, .iw-reveal');
    if(!animEls.length) return;
    
    // Immediately show elements already in/near viewport
    animEls.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if(rect.top < window.innerHeight + 200) {
        el.classList.add('iw-in');
        el.classList.add('visible');
      }
    });
    
    if('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if(entry.isIntersecting) {
            entry.target.classList.add('iw-in');
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: 0.05, rootMargin: '100px 0px 0px 0px'});
      
      animEls.forEach(function(el) {
        if(!el.classList.contains('iw-in')) observer.observe(el);
      });
    } else {
      animEls.forEach(function(el) { el.classList.add('iw-in'); el.classList.add('visible'); });
    }
  }
  
  // ---- MARQUEE ----
  function initMarquee() {
    var tracks = document.querySelectorAll('.iw-press-track');
    tracks.forEach(function(track) {
      var speed = 0.5;
      var pos = 0;
      var width = track.scrollWidth / 2;
      var paused = false;
      function tick() {
        if(!paused) { pos -= speed; if(pos <= -width) pos = 0; track.style.transform = 'translateX(' + pos + 'px)'; }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      track.parentElement && track.parentElement.addEventListener('mouseenter', function(){paused=true;});
      track.parentElement && track.parentElement.addEventListener('mouseleave', function(){paused=false;});
    });
  }
  
  // ---- ANNOUNCEMENT ----
  function initAnnouncement() {
    var msgs = document.querySelectorAll('.iw-ann-msg');
    if(msgs.length <= 1) return;
    var idx = 0;
    setInterval(function() {
      msgs[idx].classList.remove('active');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('active');
    }, 4000);
    var closeBtn = document.querySelector('.iw-ann-close');
    if(closeBtn) {
      closeBtn.addEventListener('click', function() {
        var ann = document.querySelector('.iw-ann');
        if(ann) ann.style.display = 'none';
        var navOuter = document.getElementById('iw-nav');
        if(navOuter) navOuter.style.top = '0';
      });
    }
  }
  
  // ---- NAV ----
  function initNav() {
    var nav = document.getElementById('iw-nav');
    if(!nav) return;
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, {passive:true});
  }
  
  // ---- INIT ----
  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAnimations();
      initMarquee();
      initAnnouncement();
      initNav();
    });
  } else {
    initAnimations();
    initMarquee();
    initAnnouncement();
    initNav();
  }
  
  window.addEventListener('load', initAnimations);
  
})();